<template>
    <div class="card card-highlighted">
        <div class="card-body">
            <h4 class="card-title">You are the seller</h4>
        </div>
        <div class="card-body">
            <div class="d-flex flex-row">
                <div class="">
                    <blockie :address="trade.buyer_email" :width="100"></blockie>
                </div>
                <div class="p-l-20">
                    <h3 class="font-medium">{{trade.buyer_first_name}} {{trade.buyer_last_name}}</h3>
                    <h6>Buyer</h6>
                </div>
            </div>
            <div class="row m-t-40">
                <div class="col b-r text-center">
                    <h3 class="font-light">{{trade.trade_status}}</h3>
                    <h6>State</h6>
                </div>
                <div class="col text-center">
                    <h3 class="font-light" v-if="trade.total_amount">{{trade.total_amount | money}}</h3>
                    <h6>Total Amount</h6>
                </div>
            </div>
        </div>

        <div>
<!--            <hr>-->
        </div>

        <template v-if="trade.contract_type === 'FORWARD'">
            <accept :events="events" :trade="trade" v-if="trade.trade_status === 'OPEN' && isOfferOwner()"></accept>
            <accept-pending :events="events" :trade="trade" v-if="trade.trade_status === 'OPEN' && !isOfferOwner()"></accept-pending>
            <sign :events="events" :trade="trade" v-else-if="trade.trade_status === 'ACCEPTED'"></sign>
<!--            <escrow-pending :events="events" :trade="trade" v-else-if="trade.trade_status === 'SIGNED'"></escrow-pending>-->
<!--            <schedule :events="events" :trade="trade" v-else-if="trade.trade_status === 'ESCROWED'"></schedule>-->
<!--            <ship :events="events" :trade="trade" v-else-if="trade.trade_status === 'SCHEDULED'"></ship>-->
<!--            <release-pending :events="events" :trade="trade" v-else-if="trade.trade_status === 'SHIPPED'"></release-pending>-->
<!--            <paid :events="events" :trade="trade" v-else-if="trade.trade_status === 'RELEASED'"></paid>-->
<!--            <complete :events="events" :trade="trade" v-else-if="trade.trade_status === 'COMPLETE'"></complete>-->
        </template>

        <template v-if="trade.contract_type === 'SPOT'">
            <accept :events="events" :trade="trade" v-if="trade.trade_status === 'OPEN' && isOfferOwner()"></accept>
            <accept-pending :events="events" :trade="trade" v-if="trade.trade_status === 'OPEN' && !isOfferOwner()"></accept-pending>
            <sign :events="events" :trade="trade" v-else-if="trade.trade_status === 'ACCEPTED'"></sign>
<!--            <pay-pending :events="events" :trade="trade" v-else-if="trade.trade_status === 'SIGNED'"></pay-pending>-->
<!--            <schedule :events="events" :trade="trade" v-else-if="trade.trade_status === 'PAYMENT'"></schedule>-->
<!--            <ship :events="events" :trade="trade" v-else-if="trade.trade_status === 'SCHEDULED'"></ship>-->
<!--            <withdraw-spot :events="events" :trade="trade" v-else-if="trade.trade_status === 'SHIPPED'"></withdraw-spot>-->
<!--            <paid :events="events" :trade="trade" v-else-if="trade.trade_status === 'RELEASED'"></paid>-->
<!--            <complete :events="events" :trade="trade" v-else-if="trade.trade_status === 'COMPLETE'"></complete>-->
        </template>


<!--        <div class="p-25 border-top m-t-15" v-if="canBeCancelled()">-->
<!--            <div class="row text-center">-->
<!--                <div class="col-6 border-right">-->
<!--                    <a class="link d-flex align-items-center justify-content-center font-medium" href="#">-->
<!--                        <i class=" fas fa-gavel font-15 m-r-5"></i>&nbsp;Dispute-->
<!--                    </a>-->
<!--                </div>-->
<!--                <div class="col-6">-->
<!--                    <a class="link d-flex align-items-center justify-content-center font-medium" href="#">-->
<!--                        <i class="fas fa-times-circle font-15 m-r-5"></i>&nbsp;Cancel-->
<!--                    </a>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../../../common/Blockie";
    import Accept from "./slots/Accept";
    import AcceptPending from "./slots/AcceptPending";
    import Sign from "./slots/Sign";
    import EscrowPending from "./slots/EscrowPending";
    import Schedule from "./slots/Schedule";
    import Ship from "./slots/Ship";
    import ReleasePending from "./slots/ReleasePending";
    import Paid from "./slots/Paid";
    import Complete from "./slots/Complete";
    import PayPending from "./slots/PayPending"
    import WithdrawSpot from "./slots/WithdrawSpot";

    export default {
        name: "TradeSidebar",
        components: {Blockie, Accept, AcceptPending, Sign, EscrowPending, Schedule, Ship, ReleasePending, Paid, Complete, PayPending, WithdrawSpot},
        computed: {
            ...mapGetters(["currentUser"])
        },
        props: {
            tradeid: String,
            trade: Object,
            events: Object
        },
        methods: {
            isOfferOwner() {
                return this.trade.offer_owner === this.currentUser.id;
            },
            canBeCancelled() {
                return ["ACCEPTED", "SIGNED", "ESCROWED", "SCHEDULED", "SHIPPED"].includes(this.trade.trade_status);
            }
        }
    }
</script>

<style scoped>

</style>
